// get find-an-etf dropdown label and save for later
const dropdown_label = $("#find-an-etf-dropdown .dropdown__label").text();
// FindYourInvestmentSolution/ find-an-etf close button
$('.find-an-etf__close').on("click", (e) => {
    $(".find-an-etf .find-an-etf__content .active.show").removeClass('active show');
    $("#find-an-etf-dropdown .dropdown__label").text(dropdown_label);
    $(".find-an-etf .dropdown-item.dropdown__item.active").removeClass("active");
    $("#find-an-etf-dropdown").dropdown('show');
    $(".find-an-etf .dropdown .dropdown-menu.dropdown__menu").css({ opacity: 0 });
    $(".find-an-etf .dropdown .dropdown-menu")[0].scroll(0, 0);
    $("#find-an-etf-dropdown").dropdown('hide');
    $(".find-an-etf .dropdown .dropdown-menu.dropdown__menu").css({ opacity: 1 });
});

const selectGoldInvestingOption = (container) => {
    let link = container.querySelector('#gold-investing-link')
    if (!link) return;
    link.click();
}

const loadCarouselScripts = async () => {
  await import("../sources/carousels.js");
  window.__carouselsLoaded = true;
}

window.addEventListener("DOMContentLoaded", () => {
    let container = document.querySelector('.home-page #FindYourInvestmentSolution');

    if (!container) return;

    if (!window.__carouselsLoaded) loadCarouselScripts();

    const observerOptions = { root: null, threshold: 0.01 };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                selectGoldInvestingOption(entry.target);
                observer.unobserve(entry.target);
            }
        });
    };

    const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions);

    intersectionObserver.observe(container);
});